import styled from 'styled-components';
import {
  StyledCandidateResultsList,
  StyledComposerInput,
  StyledMessageBubble,
  StyledUserMessageRow,
} from '../../../Assistant/Assistant.styles';

export const MINI_CHAT_WIDTH = 360;
export const MINI_CHAT_MOBILE_HEIGHT = 320;
export const MINI_CHAT_TRANSITION_MS = 300;

export const StyledMiniChatPanel = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: ${MINI_CHAT_WIDTH}px;
  border-left: 1px solid ${({ theme }) => theme.colors.BORDER};
  background: ${({ theme }) => theme.colors.BG};

  @media (max-width: 1100px) {
    right: 0;
    bottom: auto;
    width: auto;
    height: ${MINI_CHAT_MOBILE_HEIGHT}px;
    border-left: none;
    border-top: 1px solid ${({ theme }) => theme.colors.BORDER};
  }
`;

export const StyledMiniChatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 14px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.BORDER};
  background: ${({ theme }) => theme.colors.CARD};
  overflow: visible;
`;

export const StyledMiniChatTitle = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.TITLE};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledMiniChatHeaderActions = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
  overflow: visible;
`;

export const StyledMiniChatHeaderButton = styled.button<{ $icon?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ $icon }) => ($icon ? '28px' : 'auto')};
  height: ${({ $icon }) => ($icon ? '28px' : 'auto')};
  padding: ${({ $icon }) => ($icon ? '0' : '4px 8px')};
  border: none;
  border-radius: 6px;
  background: transparent;
  color: ${({ theme }) => theme.colors.BLUE.B400};
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.BG1};
    color: ${({ theme }) => theme.colors.BLUE.B500};
  }

  &:disabled {
    opacity: 0.45;
    cursor: default;
  }
`;

export const StyledMiniChatMessages = styled.div`
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${StyledCandidateResultsList} {
    max-width: 100%;
    margin-top: 8px;
    gap: 8px;
  }

  ${StyledUserMessageRow} {
    max-width: 85%;
  }

  ${StyledMessageBubble} {
    width: fit-content;
    max-width: 100%;
    padding: 8px 12px;
    font-size: 13px;
    line-height: 18px;
  }
`;

export const StyledMiniChatMessageColumn = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $fullWidth }) => ($fullWidth ? 'flex-start' : 'flex-end')};
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  max-width: 85%;
  min-width: 0;
  gap: 8px;

  ${StyledCandidateResultsList} {
    width: 100%;
  }
`;

export const StyledMiniChatEmpty = styled.div<{ $inline?: boolean }>`
  display: flex;
  flex: ${({ $inline }) => ($inline ? 'none' : 1)};
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.LABEL};
  font-size: 13px;
  line-height: 18px;
  text-align: ${({ $inline }) => ($inline ? 'left' : 'center')};
  padding: ${({ $inline }) => ($inline ? '8px 0 0' : '16px')};
`;

export const StyledMiniChatComposer = styled.form`
  display: flex;
  align-items: flex-end;
  padding: 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.BORDER};
  background: ${({ theme }) => theme.colors.CARD};
`;

export const StyledMiniChatInputWrap = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
`;

export const StyledMiniChatInput = styled(StyledComposerInput)`
  width: 100%;
  min-height: 40px;
  max-height: 96px;
  padding: 8px 40px 8px 12px;
`;

export const StyledMiniChatSend = styled.button<{ $isLoading?: boolean }>`
  position: absolute;
  right: 6px;
  bottom: 6px;
  width: 28px;
  height: 28px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  background: ${({ theme, $isLoading }) =>
    $isLoading ? theme.colors.BLUE.B350 : theme.colors.BLUE.B400};
  color: ${({ theme }) => theme.colors.NEUTRAL.N0};
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.BLUE.B500};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;
